module.exports = __webpack_public_path__ + "static/media/solo34.0533bdee.JPG";